// extracted by mini-css-extract-plugin
export default {"root":"AssignmentEndedNotice_root__xQAdD","text":"AssignmentEndedNotice_text__+h3Lx","action":"AssignmentEndedNotice_action__B6jCq","dismiss":"AssignmentEndedNotice_dismiss__y2fHB"};